var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "アカウント管理",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x align-justify" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.isEditAccount
            ? _c(
                "div",
                {
                  staticClass: "medium-3 cell",
                  attrs: { "data-test": "create-account" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "float-right boss-button boss-button-new",
                      attrs: { "data-test": "button-add-account" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "settingAccountRegister",
                          })
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "boss-icon-new" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "boss-button-new-text" }, [
                        _vm._v("アカウントを追加する"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "unstriped hover boss-table" }, [
          _c("thead", [
            _c(
              "tr",
              [
                _c(
                  "th",
                  { staticClass: "boss-table-head-center boss-user-name" },
                  [_vm._v("\n            氏名\n          ")]
                ),
                _vm._v(" "),
                _c("th", { staticClass: "boss-table-head-center" }, [
                  _vm._v("\n            メールアドレス\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  { staticClass: "boss-table-head-center boss-permissions" },
                  [_vm._v("\n            権限設定\n          ")]
                ),
                _vm._v(" "),
                _c("th", { staticClass: "boss-table-head-center" }, [
                  _vm._v("\n            メール受信設定\n          "),
                ]),
                _vm._v(" "),
                _vm.isEditAccount
                  ? [
                      _c(
                        "th",
                        {
                          staticClass: "boss-table-head-center boss-operation",
                        },
                        [_vm._v("\n              編集\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "boss-table-head-center boss-operation",
                        },
                        [_vm._v("\n              削除\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass:
                            "boss-table-head-center boss-temporary-password",
                        },
                        [_vm._v("\n              ID/仮PASS送信\n            ")]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.staffs, function (staff, i) {
              return _c(
                "tr",
                { key: i },
                [
                  _c("td", { staticClass: "boss-table-data" }, [
                    _c("span", { attrs: { "data-test": "staff-name-" + i } }, [
                      _vm._v(_vm._s(_vm._f("formatData")(staff.staffName))),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    staff.isAdmin
                      ? _c(
                          "span",
                          {
                            staticClass: "boss-annotation-text",
                            attrs: { "data-test": "staff-name-admin-" + i },
                          },
                          [_c("b", [_vm._v("※設定管理者")])]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "boss-table-data pega-break",
                      attrs: { "data-test": "staff-address-" + i },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("formatData")(staff.email)) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "boss-table-data" },
                    _vm._l(staff.permissions, function (permission, j) {
                      return _c(
                        "div",
                        {
                          key: j,
                          staticClass: "text-left",
                          attrs: {
                            "data-test": "staff-permission-" + i + "-" + j,
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(permission.name) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "boss-table-data" },
                    _vm._l(
                      staff.receivableMailTypes,
                      function (receivableMailType, j) {
                        return _c(
                          "div",
                          {
                            key: j,
                            staticClass: "text-left",
                            attrs: {
                              "data-test":
                                "staff-receivable-mail-type-" + i + "-" + j,
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(receivableMailType.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                  _vm._v(" "),
                  _vm.isEditAccount
                    ? [
                        _c("td", { staticClass: "boss-table-data" }, [
                          _c("button", {
                            staticClass: "boss-icon-pencil",
                            attrs: { "data-test": "staff-edit-icon-" + i },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  name: "settingAccountEdit",
                                  params: { id: staff.id },
                                })
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "boss-table-data" }, [
                          !staff.isAdmin
                            ? _c("button", {
                                staticClass: "boss-icon-trash",
                                attrs: {
                                  "data-test": "staff-delete-icon-" + i,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.doRemove(staff.id)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "boss-table-data" }, [
                          !staff.isAdmin
                            ? _c(
                                "button",
                                {
                                  staticClass: "boss-button",
                                  attrs: {
                                    "data-test": "staff-id-pass-button-" + i,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.doSend(staff.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "boss-button-new-text" },
                                    [_vm._v("ID/仮PASS送信")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medium-9 cell" }, [
      _c("p", [
        _vm._v(
          "この企業様管理画面にログインできるご担当者様の各種設定を行います。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          ※設定の変更が行えるのは、設定管理者に設定されているご担当者様のみです。\n          "
        ),
        _c("br"),
        _vm._v("※ユーザーは１０人まで登録できます。\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }